export default __webpack_public_path__ + "static/media/eve-no-jikan-wide.29a5c85f.png";